import { styled } from '@mui/material/styles';
import { ShoppingCart } from 'lucide-react';
import { usePlanSelectionCtx } from '../../../pages/plans/shared/plan-selection/plan-selection-context';
import { Button, ButtonProps } from '@mui/material';

// ─── Component ────────────────────────────────────────────────────────────────

export function CartButton(props: ButtonProps) {
  const { cart, openCheckout } = usePlanSelectionCtx();
  const count = [cart.ma, cart.mg, cart.pdp].filter(Boolean).length;

  if (count === 0) return null;

  return (
    <CartBtn onClick={openCheckout} aria-label={`Open cart (${count} plan${count > 1 ? 's' : ''})`} {...props}>
      <ShoppingCart size={14} aria-hidden />
      <CartCount>{count}</CartCount>
    </CartBtn>
  );
}

// ─── Styled ───────────────────────────────────────────────────────────────────

const CartBtn = styled(Button)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  padding: '0 12px',
  height: 28,
  fontSize: 12,
  fontWeight: 700,
  borderRadius: 999,
  border: 'none',
  background: '#009689',
  color: 'white',
  cursor: 'pointer',
  boxShadow: '0 2px 8px rgba(0,150,137,0.35)',
  transition: 'background 150ms',
  flexShrink: 0,
  '&:hover': { background: '#008276' },
});

const CartCount = styled('span')({
  background: '#dc2626',
  color: 'white',
  fontSize: 10,
  fontWeight: 700,
  width: 16,
  height: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  border: '1.5px solid white',
  lineHeight: 1,
});
